export default {
  subtitle:
    "Plongez au cœur de la conformité CBAM, des calculs d'émissions de carbone et des meilleures pratiques de l'industrie",
  no_posts: "Aucun article disponible",
  loading: "Chargement...",
  read_time: "{minutes} min de lecture",
  minute: "min",
  share: "Partager :",
  back_to_list: "Retour à la liste des blogs",
  article_not_found: "Article introuvable",
  article_not_found_desc: "Désolé, l'article que vous recherchez n'existe pas",
  cta_title: "Prêt à commencer votre parcours de conformité CBAM ?",
  cta_subtitle:
    "Essayez TaxEcoBit maintenant pour générer facilement des rapports d'émissions de carbone conformes à l'UE",
  cta_button: "Essayer maintenant",
};
